import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { FormClassApply, FormKbn } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { GlobalContext } from "../../context/globalContext";
import { ITkDataTableBodyProps } from "../../type/componentsType/TkDataTable";
import { httpAPI_INQ010 } from "./api/request";
import { headList, tableTitle } from "./parts";
import { getListData } from "./hooks/getListData";
import "./_style.scss";

/**
 * SCRS080001 掛金対象法人・職員情報照会
 * @return SCRS080001
 */
const SCRS080001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const date = new Date();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const MonthDay = `${month}/${day}`;
  const isBeforeAug = MonthDay < "08/01";
  const [bodyList, setBodyList] = useState<ITkDataTableBodyProps[][]>([]);
  const [formData, setFormData] = useState<any>({ fileBase64: "" });

  useEffect(() => {
    handleCallApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallApi = async (year?: any) => {
    let fiscalYear = state.authInfo?.fiscalYear!;
    try {
      const res = await httpAPI_INQ010({
        year:
          year !== undefined && year !== null
            ? Number(year)
            : isBeforeAug
            ? Number(fiscalYear) - 1
            : Number(fiscalYear),
      });

      if (res.resultCd === "I0000") {
        let bodyList: ITkDataTableBodyProps[][] =
          res.consentContractorList?.map((item: any) => [
            {
              children: item.consentDate,
              forSort: item.consentDate,
            },
            {
              children: item.contractorNo,
              forSort: item.contractorNo,
            },
            {
              children: item.corpName,
              forSort: item.corpName,
            },
          ])!;

        setBodyList(bodyList);

        let formData = res.formList?.find(
          (item: any) =>
            item.formKbn === FormKbn["申請"] &&
            item.formClass ===
              FormClassApply["掛金納付対象職員届確定状況一覧（社協等用）"]
        )!;

        formData && setFormData(formData);
        setState({ ...state, errorMsgId: "" });
      } else if (res.resultCd === "TKMSG_SVR0017W") {
        setState({ ...state, errorMsgId: res.resultCd });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  let year = date.getFullYear();
  return (
    <Box className="SCRS080001" data-testid="SCRS080001PageForTest">
      <TkInfoManual rule="\n">{labelids.labelid.LBLS080001_01}</TkInfoManual>

      <TkSearchForm
        listData={getListData(isBeforeAug ? year - 1 : year)}
        onSearch={(e: any) => {
          handleCallApi(e.year);
        }}
      />

      <TkDataTable
        headList={headList}
        bodyList={bodyList}
        headerLeftComponent={<Typography>{tableTitle}</Typography>}
        pagin
      />

      <Box className="button">
        <TkDownloadLink
          dataname={"掛金納付対象職員届確定状況一覧（社協等用）"}
          base64filedata={formData.fileBase64}
          downloadBase64={true}
          isButton
          buttonName="ダウンロード"
        />
      </Box>
    </Box>
  );
};

export default SCRS080001;
